import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  productAddonsContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  productsAndDeliveryTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  addonsContentBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '10px 0px',
    height: 'fit-content',
    gap: '8px',
    '@media (min-width: 640px)': {
      gap: '16px',
    },
  },
  addonsContentBox2: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '10px 0px',
    height: 'fit-content',
    gap: '8px',
  },
  checkChanges: {
    padding: '0px',
  },
  addonsElementsCB: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    gap: '8px',
  },
  addonsElementsCB2: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    gap: '16px',
  },
  propertyOwnerText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
    margin: 'auto 0px',
  },
  propertyOwnerSubText: {
    color: theme.evPalette.charcoal[700],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
  },
  propertyOwnerCBText: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
    margin: 'auto 0px',
  },
  productSubstitutionsButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '16px 24px',
    gap: '15px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  cancelButtonClass: {
    padding: '10px 16px',
    borderColor: theme.evPalette.salt[100],
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
  saveButtonClass: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
}));
